<!-- 通知配置页面 -->
<template>
  <div class="notificationConfig">
    <div class="head-area clr">
      <div class="fl clr left-search">
        <div class="fl search-item">
          <div class="fl head-label-area">通知编号</div>
          <Input class="fl" v-model="keywords" placeholder="通知编号" clearable style="width:200px"></Input>
        </div>
        <div class="fl search-item">
          <div class="fl head-label-area">通知名称</div>
          <Input class="fl" v-model="name" placeholder="通知名称" clearable style="width:200px"></Input>
        </div>
      </div>
      <div class="fr right-search-btn">
        <Button type="primary" style="margin-right:10px;" icon="ios-search" @click="search">查询</Button>
        <Button @click="reset" icon="ios-refresh">重置</Button>
      </div>
    </div>
    <div class="add-btn clr">
        <Button  class="fr" type="primary"  icon="ios-add" @click="add">新增模版</Button>
    </div>
    <div class="table-area">
      <Table :columns="columns" :data="dataList" size="small" :height="tableHeight">
        <template slot-scope="{ row }" slot="action">
          <a @click="edit(row)" style="margin-right:10px">编辑</a>
          <a @click="del(row)" style="margin-right:0px">删除</a>
        </template>
      </Table>
    </div>
    <div class="page-area" v-if="dataList.length">
      <Page
        :total="total"
        :current="current"
        :page-size="size"
        show-total
        @on-change="pageChage"
        @on-page-size-change="pageSizeChage"
      ></Page>
    </div>
    <!-- <div class="packageManagement" v-if="comboManagementShow">
      <comboManagement
        @back="comboManagementShow = false"
        :storeId="currentData.id"
        v-if="comboManagementShow"
      />
    </div>-->
  </div>
</template>

<script>

// import { getStoreList } from '@/api/businessManagement.js'


export default {
  components: {
  },
  data() {
    return {
      keywords: '',
      name:'',
      tableHeight: window.innerHeight - 330,
      total: 0,
      current: 1,
      size: 20,
      columns: [
        {
          title: '编号',
          type: 'index'
        },
        {
          title: '名称',
          key: 'storeName',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '内容',
          key: 'content',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '通知渠道',
          key: 'activeTime',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '发送范围',
          key: 'storeName',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '发布时间',
          key: 'num',
        },
        {
          title: '启动状态',
          key: 'state',
          ellipsis: true,
          tooltip: true,
        },
        {
          title: '操作',
          width: 130,
          slot: 'action',
        },
      ],
      dataList: [],
    };
  },
  created() {
    this.findPageDataList()
  },
  methods: {
    reset() {
      this.keywords = ''
      this.search()
    },
    search() {
      this.current = 1
      this.findPageDataList()
    },
    findPageDataList() {
      //   let params = { size: this.size, pageIndex: this.current }
      //   if (this.keywords) {
      //     params.keywords = this.keywords
      //   }
      //   getStoreList(params).then(res => {
      //     if (res.success) {
      //       this.dataList = res.result.list
      //       this.total = res.result.total
      //     }
      //   })
    },
    add(){},
    edit(row) {
      console.log(row)
    },
    del(row) {
      this.$Modal.confirm({
        title: "确认删除？",
        onOk: () => {
          console.log(row)
          //   delStore({ id: row.id }).then(res => {
          //     if (res.success) {
          //       this.$Message.success('删除成功！')
          //       this.findPageDataList()
          //     }
          //   });
        },
      })
    },
    pageChage(page) {
      this.current = page
      this.findPageDataList()
    },
    pageSizeChage(size) {
      this.size = size
      this.findPageDataList()
    }
  }
}

</script>
<style lang='scss' scoped>
.notificationConfig {
  .left-search {
    width: calc(100% - 220px);
    .search-item {
      margin-bottom: 10px;
    }
  }
  .right-search-btn {
    width: 200px;
    border-left: 1px solid #e5e6eb;
    padding-left: 15px;
  }
  .head-label-area {
    line-height: 36px;
    // width: 120px;
    margin-left: 10px;
    padding-right: 15px;
    text-align: right;
  }
  .add-btn {
    margin: 20px 0;
  }
}
</style>